
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { MapViewModel, MapService } from '../../api/map';
import MapList from './List.vue';

@Component({
  components: {
    MapList,
  },
})
export default class MapIndex extends Vue {
  private service: MapService = new MapService();
  private condition: MapViewModel = this.service.NewModel;
  private totalCount: number = 0;

  private map_OnLoaded(totalCount: number) {
    console.log(totalCount);
    this.totalCount = totalCount;
  }
}
